export default __webpack_public_path__ + "static/media/RDM_05.124010c3.png";